/**
 * Sanitize CMS-sourced rich text HTML before rendering with dangerouslySetInnerHTML.
 * Removes script elements and inline event handlers. Safe to call in both SSR and browser.
 */
export function sanitizeRichText(html: string): string {
  // Remove <script>...</script> blocks
  const noScript = html.replaceAll(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");
  // Remove inline event handler attributes (onerror=, onclick=, onload=, etc.)
  return noScript.replaceAll(/\s+on\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]*)/gi, "");
}
